import { render, staticRenderFns } from "./mocImprTabDetail.vue?vue&type=template&id=37d94aac"
import script from "./mocImprTabDetail.vue?vue&type=script&lang=js"
export * from "./mocImprTabDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d94aac')) {
      api.createRecord('37d94aac', component.options)
    } else {
      api.reload('37d94aac', component.options)
    }
    module.hot.accept("./mocImprTabDetail.vue?vue&type=template&id=37d94aac", function () {
      api.rerender('37d94aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocImprTabDetail.vue"
export default component.exports